import { createFileRoute } from '@tanstack/react-router';

import { TailoredSupplyPage } from '../features/campaigns/supply/TailoredSupplyPage';

export const Route = createFileRoute('/campaigns/supply/tailored-supply')({
  component: TailoredSupplyPage,
});
